import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Marquee from "react-fast-marquee";
import BlogCard from "../components/BlogCard";
import ProductCard from "../components/ProductCard";
import SpecialProduct from "../components/SpecialProduct";
import Container from "../components/Container";
import { services } from "../utils/Data";
import prodcompare from "../images/prodcompare.svg";
import wish from "../images/wish.svg";
import wishlist from "../images/wishlist.svg";
import watch from "../images/watch.jpg";
import watch2 from "../images/watch-1.avif";
import addcart from "../images/add-cart.svg";
import view from "../images/view.svg";
import { useDispatch, useSelector } from "react-redux";
import { getAllBlogs } from "../features/blogs/blogSlice";
import moment from "moment";
import ReactStars from "react-rating-stars-component";
import { addToWishlist, getAllProducts } from "../features/products/productSlilce";
import { AiFillHeart, AiOutlineHeart } from "react-icons/ai";
import { getAllBanners } from "../features/banners/bannerSlice";

const Home = () => {
  const blogState = useSelector((state) => state?.blog?.blog);
  const productState = useSelector((state) => state?.product?.product);
  const bannerState = useSelector((state) => state?.banner?.banner);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    getblogs();
    getProducts();
    getBanners();
  }, []);
  const getblogs = () => {
    dispatch(getAllBlogs());
  };

  const getProducts = () => {
    dispatch(getAllProducts());
  };

  const getBanners = () => {
    dispatch(getAllBanners());
  };

  const mainBanners = bannerState?.filter((banner) => banner.role === "main");
  const smallBanners = bannerState?.filter((banner) => banner.role === "small");

  const addToWish = (id) => {
    //alert(id);
    dispatch(addToWishlist(id));
  };
  return (
    <>
      <Container class1="home-wrapper-1 py-5">
        <div className="row">
          <div className="col-12 col-md-6 mb-4 mb-md-0">
            {mainBanners?.length > 0 ? (
              mainBanners.map((banner, index) => (
                <div key={index} className="main-banner position-relative ">
                  <img
                    src={banner?.images?.[0]?.url || "images/main-banner-1.jpg"}
                    className="img-fluid rounded-3"
                    alt="main banner"
                  />
                  <div className="main-banner-content position-absolute">
                    <h4>{banner?.title}</h4>
                    <h5>{banner?.subtitle}</h5>
                    <p>{banner?.price}</p>
                    <Link to={banner?.link} className="button">BUY NOW</Link>
                  </div>
                </div>
              ))
            ) : (
              <p>No main banner configured.</p>
            )}
          </div>
          <div className="col-12 col-md-6">
            <div className="d-flex flex-wrap gap-10 justify-content-between align-items-center">
              {smallBanners?.length > 0 ? (
                smallBanners.map((banner, index) => (
                  <div key={index} className="small-banner position-relative">
                    <img
                      src={banner?.images?.[0]?.url || "images/catbanner-01.jpg"}
                      className="img-fluid rounded-3"
                      alt="small banner"
                      style={{ objectFit: 'cover' }}
                    />
                    <div className="small-banner-content position-absolute">
                      <h4>{banner?.title}</h4>
                      <h5>{banner?.subtitle}</h5>
                      <p>{banner?.price}</p>
                    </div>
                  </div>
                ))
              ) : (
                <p>No small banners configured.</p>
              )}
            </div>
          </div>
        </div>
      </Container>
      <Container class1="home-wrapper-2 py-5">
        <div className="row">
          <div className="col-12">
            <div className="servies d-flex align-items-center justify-content-between flex-wrap gap-15">
              {services?.map((i, j) => {
                return (
                  <div className="d-flex align-items-center gap-15" key={j}>
                    <img src={i.image} alt="services" />
                    <div>
                      <h6>{i.title}</h6>
                      <p className="mb-0">{i.tagline}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </Container>
      {/* <Container class1="home-wrapper-2 py-5">
        <div className="row">
          <div className="col-12">
            <div className="categories d-flex justify-content-between flex-wrap align-items-center">
              <div className="d-flex gap align-items-center">
                <div>
                  <h6>Music & Gaming</h6>
                  <p>10 Items</p>
                </div>
                <img src="images/camera.jpg" alt="camera" />
              </div>
              <div className="d-flex gap align-items-center">
                <div>
                  <h6>Cameras</h6>
                  <p>10 Items</p>
                </div>
                <img src="images/camera.jpg" alt="camera" />
              </div>
              <div className="d-flex gap align-items-center">
                <div>
                  <h6>Smart Tv</h6>
                  <p>10 Items</p>
                </div>
                <img src="images/tv.jpg" alt="camera" />
              </div>
              <div className="d-flex gap align-items-center">
                <div>
                  <h6>Smart Watches</h6>
                  <p>10 Items</p>
                </div>
                <img src="images/headphone.jpg" alt="camera" />
              </div>
              <div className="d-flex gap align-items-center">
                <div>
                  <h6>Music & Gaming</h6>
                  <p>10 Items</p>
                </div>
                <img src="images/camera.jpg" alt="camera" />
              </div>
              <div className="d-flex gap align-items-center">
                <div>
                  <h6>Cameras</h6>
                  <p>10 Items</p>
                </div>
                <img src="images/camera.jpg" alt="camera" />
              </div>
              <div className="d-flex gap align-items-center">
                <div>
                  <h6>Smart Tv</h6>
                  <p>10 Items</p>
                </div>
                <img src="images/tv.jpg" alt="camera" />
              </div>
              <div className="d-flex gap align-items-center">
                <div>
                  <h6>Smart Watches</h6>
                  <p>10 Items</p>
                </div>
                <img src="images/headphone.jpg" alt="camera" />
              </div>
            </div>
          </div>
        </div>
      </Container> */}
      <Container class1="featured-wrapper py-5 home-wrapper-2">
        <div className="row">
          <div className="col-12">
            <h3 className="section-heading">Featured Collection</h3>
          </div>
          {productState &&
            productState?.map((item, index) => {
              if (item.tags === "featured") {
                return (
                  <div key={index} className="col-12 col-sm-6 col-lg-3 mb-4">
                    <div className="product-card position-relative">
                      <div className="discount-label position-absolute ">
                        -
                        {Math.round(
                          ((item.originalPrice - item.discountedPrice) /
                            item.originalPrice) *
                          100
                        )}
                        %
                      </div>

                      <div className="wishlist-icon position-absolute">
                        <button className="border-0 bg-transparent">
                          <img
                            src={wish}
                            alt="wishlist"
                            onClick={(e) => {
                              addToWish(item?._id);
                            }}
                          />
                        </button>
                      </div>
                      <div className="product-type-icon position-absolute">
                        <h6 className="producttype">{item?.producttype}</h6>
                      </div>
                      <div className="product-image">
                        <img
                          src={item?.images[0]?.url}
                          className="img-fluid d"
                          alt="product image"
                          height={"250px"}
                          width={"260px"}
                          onClick={() => navigate("/product/" + item?._id)}
                        />
                        <img
                          src={item?.images[0]?.url}
                          className="img-fluid d"
                          alt="product image"
                          height={"250px"}
                          width={"260px"}
                          onClick={() => navigate("/product/" + item?._id)}
                        />
                      </div>
                      <div className="product-details">
                        <h6 className="brand">{item?.brand}</h6>
                        <h5 className="product-title">
                          {item?.title?.substr(0, 70) + "..."}
                        </h5>
                        <ReactStars
                          count={5}
                          size={24}
                          value={item?.totalrating.toString()}
                          edit={false}
                          activeColor="#ffd700"
                        />

                        <p className="original-price text-muted text-decoration-line-through">
                          ₹{item.originalPrice}
                        </p>
                        <p className="discounted-price fw-bold">
                          ₹{item.discountedPrice}
                        </p>
                        <p className="tax-info text-muted">
                          (Inclusive Tax Price) ₹{item.discountedPrice}
                        </p>
                      </div>
                      <div className="action-bar position-absolute">
                        <div className="d-flex flex-column gap-15">
                          {/* <button className="border-0 bg-transparent">
                            <img src={prodcompare} alt="compare" />
                          </button>
                          <button className="border-0 bg-transparent">
                            <img
                              onClick={() => navigate("/product/" + item?._id)}
                              src={view}
                              alt="view"
                            />
                          </button> */}
                          {/* <button className="border-0 bg-transparent">
                            <img src={addcart} alt="addcart" />
                          </button> */}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              }
            })}
        </div>
      </Container>


      <Container class1="special-wrapper py-5 home-wrapper-2">
        <div className="row">
          <div className="col-12">
            <h3 className="section-heading">Special Products</h3>
          </div>
        </div>
        <div className="row">
          {productState?.length > 0 ? (
            productState.map((item, index) => {
              if (item.tags === "special") {
                return (
                  <SpecialProduct
                    key={item?._id || index}
                    id={item?._id}
                    title={item?.title || "Unknown Title"}
                    brand={item?.brand || "Unknown Brand"}
                    totalrating={item?.totalrating?.toString() || "0"}
                    originalPrice={item?.originalPrice || "N/A"}
                    discountedPrice={item?.discountedPrice || "N/A"}
                    img={item?.images?.[0]?.url || "placeholder.png"}
                    sold={item?.sold || 0}
                    quantity={item?.quantity || 0}
                  />
                );
              }
            })
          ) : (
            <p>No special products available.</p>
          )}
        </div>
      </Container>
      <Container class1="popular-wrapper py-5 home-wrapper-2">
        <div className="row">
          <div className="col-12">
            <h3 className="section-heading">Our Popular Products</h3>
          </div>
        </div>
        <div className="row">
          {productState?.length > 0 ? (
            productState.map((item, index) => {
              if (item.tags === "popular") {
                return (
                  <div key={item?._id || index} className="col-12 col-sm-6 col-lg-3 mb-4">
                    <div className="product-card position-relative">
                      <div className="discount-label position-absolute ">
                        -
                        {Math.round(
                          ((item.originalPrice - item.discountedPrice) /
                            item.originalPrice) *
                          100
                        )}
                        %
                      </div>
                      <div className="product-type-icon position-absolute">
                        <h6 className="producttype">{item?.producttype}</h6>
                      </div>
                      <div className="wishlist-icon position-absolute">
                        <button
                          className="border-0 bg-transparent"
                          onClick={() => addToWish(item?._id)}
                        >
                          <img src={wish} alt="wishlist" />
                        </button>
                      </div>
                      <div className="product-image">
                        <img
                          src={item?.images?.[0]?.url || "placeholder.png"}
                          alt="product image"
                          height={"250px"}
                          width={"100%"}
                          onClick={() => navigate("/product/" + item?._id)}
                        />
                      </div>
                      <div className="product-details">
                        <h6 className="brand">
                          {item?.brand || "Unknown Brand"}
                        </h6>
                        <h5 className="product-title">
                          {item?.title?.substr(0, 70) + "..." ||
                            "Unknown Title"}
                        </h5>
                        <ReactStars
                          count={5}
                          size={24}
                          value={parseFloat(item?.totalrating || 0)}
                          edit={false}
                          activeColor="#ffd700"
                        />
                        <p className="original-price text-muted text-decoration-line-through">
                          ₹{item.originalPrice}
                        </p>
                        <p className="discounted-price fw-bold">
                          ₹{item.discountedPrice}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              }
            })
          ) : (
            <p>No popular products available.</p>
          )}
        </div>
      </Container>

      <Container class1="marque-wrapper home-wrapper-2 py-5">
        <div className="row">
          <div className="col-12">
            <div className="marquee-inner-wrapper card-wrapper">
              <Marquee className="d-flex">
                <div className="mx-4 w-25">
                  <img src="images/brand-01.png" alt="brand" />
                </div>
                <div className="mx-4 w-25">
                  <img src="images/brand-02.png" alt="brand" />
                </div>
                <div className="mx-4 w-25">
                  <img src="images/brand-03.png" alt="brand" />
                </div>
                <div className="mx-4 w-25">
                  <img src="images/brand-04.png" alt="brand" />
                </div>
                <div className="mx-4 w-25">
                  <img src="images/brand-05.png" alt="brand" />
                </div>
                <div className="mx-4 w-25">
                  <img src="images/brand-06.png" alt="brand" />
                </div>
                <div className="mx-4 w-25">
                  <img src="images/brand-07.png" alt="brand" />
                </div>
                <div className="mx-4 w-25">
                  <img src="images/brand-08.png" alt="brand" />
                </div>
              </Marquee>
            </div>
          </div>
        </div>
      </Container>

      <Container class1="blog-wrapper py-5 home-wrapper-2">
        <div className="row">
          <div className="col-12">
            <h3 className="section-heading">Our Latest Blogs</h3>
          </div>
        </div>
        <div className="row">
          {blogState &&
            blogState?.map((item, index) => {
              if (index < 4) {
                return (
                  <div className="col-12 col-sm-6 col-lg-3 mb-4" key={index}>
                    <BlogCard
                      id={item?._id}
                      title={item?.title}
                      description={item?.description}
                      image={item?.images[0]?.url}
                      date={moment(item?.createdAt).format(
                        "MMMM Do YYYY, h:mm a"
                      )}
                    />
                  </div>
                );
              }
            })}
        </div>
      </Container>
    </>
  );
};

export default Home;
